(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["celtic-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCelticLoadMore(section) {
      var button = section.querySelector('.lwb-celtic-grid__load');
      var grid = section.querySelector('.lwb-celtic-grid__items');
      if (!button || !grid || button.dataset.bound === 'true') return;

      button.dataset.bound = 'true';

      function setLoading(isLoading) {
        button.classList.toggle('is-loading', isLoading);
        button.disabled = isLoading;
      }

      function loadNext() {
        var nextUrl = button.dataset.nextUrl;
        if (!nextUrl || button.classList.contains('is-loading')) return;

        setLoading(true);
        var fetchUrl = nextUrl + (nextUrl.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + section.dataset.sectionId;

        fetch(fetchUrl)
          .then(function (response) {
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var newGrid = doc.querySelector('.lwb-celtic-grid__items');
            var newButton = doc.querySelector('.lwb-celtic-grid__load');

            if (newGrid) {
              grid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
            }

            if (newButton && newButton.dataset.nextUrl) {
              button.dataset.nextUrl = newButton.dataset.nextUrl;
              setLoading(false);
            } else {
              if (button._observer) button._observer.disconnect();
              var wrap = button.closest('.lwb-celtic-grid__load-wrap');
              if (wrap) wrap.remove();
            }
          })
          .catch(function () {
            setLoading(false);
          });
      }

      button.addEventListener('click', loadNext);

      if ('IntersectionObserver' in window) {
        button._observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadNext();
          });
        }, { rootMargin: '700px 0px' });
        button._observer.observe(button);
      }
    }

    function initAll() {
      document.querySelectorAll('.lwb-celtic-grid').forEach(initCelticLoadMore);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (event.target) {
        event.target.querySelectorAll('.lwb-celtic-grid').forEach(initCelticLoadMore);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["celtic-symbolism-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(root) {
      if (root.dataset.tabsBound === 'true') return;
      root.dataset.tabsBound = 'true';
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));

      function select(tab, focus) {
        tabs.forEach(function (other) {
          var on = other === tab;
          other.setAttribute('aria-selected', on ? 'true' : 'false');
          other.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            event.preventDefault();
            select(next, true);
          }
        });
      });

      // Theme editor: show the panel of the block being edited.
      root.addEventListener('shopify:block:select', function (event) {
        var tab = root.querySelector('[aria-controls="lwb-meaning-panel-' + event.detail.blockId + '"]');
        if (tab) select(tab, false);
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-lwb-tabs]').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
